import type { ChatbotState } from "../../reducer/types/chatbot.reducer.type";
import type { IChatbotChatStatusService, ShouldBeInEmptyStateProps } from "./chatbot-chat-status.service.interface";

export class ChatbotChatStatusService implements IChatbotChatStatusService {
  public shouldBeInEmptyState({ currentInputLength, currentMessagesLength }: ShouldBeInEmptyStateProps): boolean {
    const hasAtLeastOneMessage = currentMessagesLength !== undefined && currentMessagesLength > 0;
    const isInputEmpty = currentInputLength === undefined || currentInputLength === 0;
    const shouldBeEmptyState = !hasAtLeastOneMessage && !isInputEmpty;

    return shouldBeEmptyState;
  }

  public shouldSkipEmptyState(shouldBeInEmptyState: boolean, isCurrentlyInEmptyState?: boolean): boolean {
    const isCorrectlyInEmptyState = isCurrentlyInEmptyState && shouldBeInEmptyState;
    const isCorrectlyInNormalState = !isCurrentlyInEmptyState && !shouldBeInEmptyState;

    return isCorrectlyInEmptyState || isCorrectlyInNormalState;
  }

  public isChatDisabled(state: ChatbotState, isChatbotOpen: boolean): boolean {
    if (!isChatbotOpen) {
      return true;
    }

    if (!this._isAvailableInCurrentSubscription(state)) {
      return true;
    }

    if (this._isChatbotPerformingAction(state)) {
      return true;
    }

    if (this._isChatbotHandlingSession(state)) {
      return true;
    }

    return false;
  }

  private _isAvailableInCurrentSubscription(state: ChatbotState): boolean {
    const isChatbotUnavailableForCurrentSubscription = state.isAvailableInCurrentSubscription;
    return isChatbotUnavailableForCurrentSubscription ?? false;
  }

  private _isChatbotPerformingAction(state: ChatbotState): boolean {
    const isPerformingAction = state.isSending || state.isStreamingResponse;

    return isPerformingAction ?? false;
  }

  private _isChatbotHandlingSession(state: ChatbotState): boolean {
    const isChatbotHandlingSession = state.isCreatingNewSession || state.isCloningFromPreviousChat;

    return isChatbotHandlingSession ?? false;
  }
}
